export default "__VITE_ASSET__B1GIb59T__"